import React, { useMemo } from "react";
import {IconButton, LinearProgress, Paper , Button} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Link } from "react-router-dom";


const sortIcon = <ArrowDownward/>;

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        table: {
            minWidth: 650,
        },
    },
    btn: {
        margin: theme.spacing(4)
      }

}));

const GiftsList = ({giftsList, editGifts, deleteGifts, check, singleGiftsById}) => {
    const classes = useStyles();
    const heading = [
        {
            name: "Sr. No",
            wrap: true,
            sortable: true,
            cell: (row, index) => index + 1,
        }, {
            name: "StarCoins",
            selector: "StarCoins",
            wrap: true,
            sortable: true,
        }, {
            name: "Popularity",
            selector: "popularity",
            wrap: true,
            sortable: true,
        }, {
            name: "Gift Image",
            selector: "bonus",
            wrap: true,
            sortable: true,

            cell: (giftsList) => (<div>
                <img style={{height: '60px', width: '60px'}} src={giftsList.giftImg} alt="img"/>
            </div>)
        }, {
            name: "Action",
            wrap: true,
            center: true,

            cell: (giftsList) => (
                <div>
                    <Link to={"/dashboard/create-gifts/"+giftsList._id}>
                    <IconButton
                        edge="end"
                        aria-label="edit"

                    >
                        <EditIcon color="primary"/>
                    </IconButton>
                    </Link>

                    <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => {
                            deleteGifts(giftsList._id)
                        }}
                    >
                        <DeleteIcon color="primary"/>
                    </IconButton>
                </div>
            )
        }
    ];

  const safeData = Array.isArray(giftsList) ? giftsList : [];

  const columns = useMemo(
    () => [
      {
        name: "Sr. No",
        wrap: true,
        sortable: true,
        // DataTable passes (row, index) — we use row,index and guard index
        cell: (row, index) => <div>{typeof index === "number" ? index + 1 : "-"}</div>,
        width: "90px",
      },
      {
        name: "StarCoins",
        selector: (row) => row.zole ?? "-",
        wrap: true,
        sortable: true,
      },
      {
        name: "Popularity",
        selector: (row) => row.popularity ?? "-",
        wrap: true,
        sortable: true,
      },
      {
        name: "Gift Image",
        selector: (row) => row.giftImg ?? "",
        wrap: true,
        sortable: false,
        cell: (row) => (
          <div>
            <img
              style={{ height: 60, width: 60, objectFit: "cover" }}
              src={row.giftImg}
              alt={row.zole || "gift"}
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
          </div>
        ),
      },
      {
        name: "Action",
        wrap: true,
        center: true,
        cell: (row) => (
          <div style={{ display: "flex", gap: 8 }}>
            <Link to={`/dashboard/create-gifts/${row._id}`}>
              <IconButton edge="end" aria-label="edit">
                <EditIcon color="primary" />
              </IconButton>
            </Link>

            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => deleteGifts && deleteGifts(row._id)}
            >
              <DeleteIcon color="primary" />
            </IconButton>
          </div>
        ),
        width: "160px",
      },
    ],
    [deleteGifts]
  );

    return (
        <div>
            {!giftsList ? (
                <LinearProgress color="primary"/>
            ) : (
                <Paper className={classes.paper} square>
                    {check ?
                    <>
                    <Link to='/dashboard/create-gifts'><Button variant="contained" color="primary" className={classes.btn} >Add Gifts</Button></Link>
                        <DataTable
                                    columns={columns}
                                    data={safeData}
                                    noHeader
                                    pagination
                                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                                    // temporarily remove sortIcon while debugging:
                                    // sortIcon={sortIcon}
                                    striped
                                    highlightOnHover
                                    responsive
                        />
                        </>
                        : ''}
                </Paper>
            )}
        </div>
    );
};

export default GiftsList;
